export interface INavigationNode {
  title: string;
  icon?: string;
  url?: string;
  tooltip?: string;
  hidden?: boolean;
  children?: INavigationNode[];
}

export interface INavigationResponse {
  [name: string]: INavigationNode[];
}

export interface INavigationViews {
  [name: string]: INavigationNode[];
}

export interface ICurrentNode {
  url: string;
  view: string;
  nodes: INavigationNode[];
}

export interface ICurrentNodes {
  [view: string]: ICurrentNode;
}
